import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { useForm } from "react-hook-form";

import SupportCasesTable from "../../../components/Tables/SupportCasesTable";
import SupportCaseEditForm from "../../../components/EditForms/SupportCaseEditForm";
import { SelectClients } from "../../../components/Selects/SelectClients";

export default function FormSearchCases(props) {
  const [modalShow1, setModalShow1] = React.useState(false);
  const [searchFilter, setSearchFilter] = useState();
  const [editForm, setEditForm] = useState(0);
  const { register, handleSubmit, reset } = useForm();

  const onSubmitSearch = (values) => {
    setSearchFilter(values);
  };

  return (
    <>
      <Button
        className="d-flex justify-content-center shadow-sm fs-6 p-2 rounded-2 fw-normal text-dark borderColor"
        style={{ backgroundColor: "#DAA520" }}
        onClick={() => setModalShow1(true)}
      >
        <i className="bi bi-funnel"></i>&nbsp; Consultar atendimentos
      </Button>

      <Modal
        show={modalShow1}
        onHide={() => setModalShow1(false)}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header closeButton className="modalGradient">
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-white"
          >
            <i className="bi bi-funnel"></i>&nbsp; Consultar atendimentos
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#edebe9" }}>
          <p className="fs-5 fw-bold">Consultar</p>

          <Form onSubmit={handleSubmit(onSubmitSearch)}>
            <div className="d-flex flex-wrap">
              <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                <FloatingLabel controlId="floatingInput" label="Título">
                  <Form.Control
                    type="text"
                    className="form-control"
                    name="title"
                    {...register("title")}
                  />
                </FloatingLabel>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                <SelectClients register={register} />
              </div>
            </div>

            <div className="w-100">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-4">
                <div className="container d-flex align-items-center justify-content-between rowBtn d-flex flex-wrap">
                  <div className="d-flex align-items-center justify-content-start col-12 col-sm-12 col-md-12 col-lg-4">
                    <Button
                      className="d-flex justify-content-center shadow-sm fs-6 p-2 rounded-2 fw-normal text-dark borderColor"
                      type="submit"
                      style={{ backgroundColor: "#DAA520" }}
                    >
                      <i className="bi bi-funnel"></i>&nbsp; Consultar
                      atendimento
                    </Button>
                  </div>
                  <div className="d-flex align-items-center col-12 col-sm-12 col-md-6 col-lg-4">
                    {searchFilter ? (
                      <Button
                        className="d-flex justify-content-center shadow-sm fs-6 p-2 rounded-2 fw-normal text-dark borderColor"
                        type="button"
                        onClick={() => {
                          setSearchFilter();
                          reset();
                        }}
                        style={{ backgroundColor: "#DAA520" }}
                      >
                        <i className="bi bi-funnel"></i>&nbsp; Limpar Filtros
                      </Button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Form>

          {editForm == 0 ? (
            <div className="w-100">
              <div className="col-12">
                <SupportCasesTable
                  setEditForm={setEditForm}
                  filter={searchFilter}
                />
              </div>
            </div>
          ) : (
            ""
          )}

          {editForm != 0 ? (
            <SupportCaseEditForm
              supportCase={editForm}
              setEdit={setEditForm}
            />
          ) : (
            ""
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
